const reptiles = {
  leopardGeckos: {
    name: "Leopard Geckos",
    pets: [
      {
        name: "Charlie",
        image: "Charlie.jpg",
        funFact: "Charlie is my first leopard gecko. He is a sweet boy who has given up trying to shed by himself and relies on me to do it.",
      },
      {
        name: "Dr. Toboggan",
        image: "DrToboggan.jpg",
        funFact: "Dr. T (named for an alias of Frank Reynolds from It's Always Sunny), also known by me as 'The Leopard Gecko from Hell'. Look at his beady little eyes...",
      },
      {
        name: "Cheeto",
        image: "Cheeto.jpg",
        funFact: "Cheeto lives with Frito and gets along with her just fine. She is very friendly and always comes to the glass when I show up. Yes, that is a food container she enjoys resting in.",
      },
      {
        name: "Frito",
        image: "Frito.jpg",
        funFact: "Frito lives with Cheeto and gets along with her just fine. She is a little more shy on the surface but has no problem making a mad dash to her bug bowl at feeding time.",
      },
      {
        name: "Snowdrop",
        image: "Snowdrop.jpg",
        funFact: "Snowdrop is a sweet and sassy lady. She allows herself to be handled but only on her own terms.",
      },
    ],
  },
  crestedGeckos: {
    name: "Crested Geckos",
    pets: [
      {
        name: "Escanor",
        image: "Escanor.jpg",
        funFact: "My very first lizard. He is an escape artist and loves nothing more than his little fake flower.",
      },
      {
        name: "Queso",
        image: "Queso.jpg",
        funFact: "Queso is Escanor's little sister. She likes to lay parthenogenic eggs and splats herself at the glass when I show up.",
      },
      {
        name: "Cannoli",
        image: "Cannoli.jpg",
        funFact: "Cannoli is huge for a crestie, but he is a giant baby and hates being seen or handled. I paired him with Sprinkles, a proven breeder gecko, but all the eggs were infertile...",
      },
      {
        name: "Sprinkles",
        image: "Sprinkles.jpg",
        funFact: "A strong independent lady gecko who doesn't need Cannoli. She enjoys smacking her coconut against the glass, which echoes throughout the house.",
      },
      {
        name: "Tiramisu",
        image: "Tiramisu.jpg",
        funFact: "Tiramisu presents herself as a sweet little lady, and she is...except for her dancing routine in her food that she then splatters all over the glass.",
      },
    ],
  },
  dayGeckos: {
    name: "Day Geckos",
    pets: [
      {
        name: "Treecko",
        image: "Treecko.jpg",
        funFact: "Treecko is a Giant Madagascar Day Gecko. She enjoys laying eggs and smashing them against the wall, then eating them.",
      },
      {
        name: "Pickles",
        image: "Pickles.jpg",
        funFact: "Pickles is an inquisitive little Peacock Day Gecko. He is sometimes too friendly and has to be chased around the house.",
      },
    ],
  },
  otherNewCaledonians: {
    name: "Other New Caledonians",
    pets: [
      {
        name: "Magic Mike",
        image: "MagicMike.jpg",
        funFact: "Magic Mike is a Chahoua Gecko. He likes to hang in weird poses off his coconut and the hanging fixture.",
      },
      {
        name: "Minerva",
        image: "Minerva.jpg",
        funFact: "Minerva is a Leachianus Gecko. She recently had surgery to remove a cyst that was nearly 25% of her body weight out of her coelom (lizard abdomen).",
      },
    ],
  },
  otherGeckos: {
    name: "Other Geckos",
    pets: [
      {
        name: "Gollum",
        image: "Gollum.jpg",
        funFact: "Gollum is a Chinese Cave Gecko. Surprisingly, he likes to hang out in his cave.",
      },
      {
        name: "Loki",
        image: "Loki.jpg",
        funFact: "Loki is a Knob-tailed Gecko. He is not a fan of my existence and prefers to come out and dig holes when I am not around.",
      },
      {
        name: "Cuddles",
        image: "Cuddles.jpg",
        funFact: "Cuddles is a Tokay Gecko. He is just...so friendly. And loud if you annoy him.",
      },
    ],
  },
  otherLizards: {
    name: "Other Lizards",
    pets: [
      {
        name: "Caraxes",
        image: "Caraxes.jpg",
        funFact: "Caraxes is a bearded dragon. Like many, she hates eating her vegetables and I've gone through periods where I've had to hand feed her peas one by one.",
      },
      {
        name: "Corncob",
        image: "Corncob.jpg",
        funFact: "Corncob is a uromastyx. He looks at me with disgust and typically tends to hide in his cave if I'm around.",
      },
      {
        name: "Medusa",
        image: "Medusa.jpg",
        funFact: "Medusa is a blue-tongued skink. She is a mean lady who huffs angrily whenever I so much as look at her.",
      },
      {
        name: "Vermithor",
        image: "Vermithor.jpg",
        funFact: "Vermithor is an Emerald Swift. He is the fastest animal in the house and does pushups at you if he's mad.",
      },
    ],
  },
  frogs: {
    name: "Frogs",
    pets: [
      {
        name: "Chippy",
        image: "Chippy.jpg",
        funFact: "Chippy is a Chubby Frog (that is one of the names). She enjoys hiding in the dirt unseen for weeks at a time.",
      },
      {
        name: "Skittle",
        image: "Skittle.jpg",
        funFact: "Skittle is a Dendrobates Tinctorius poison dart frog. She is very active and likes to hop all over the tank, conveniently ignoring the brand new pothos I recently got her as a present.",
      },
      {
        name: "Billy",
        image: "Billy.jpg",
        funFact: "Billy is a geriatric Pacman Frog who must be hand fed due to his stubbornness. He does not enjoy being dug up from his dirt hole.",
      },
    ],
  },
  inverts: {
    name: "Invertebrates coming soon!",
    pets: [
    ],
  },

  // Add more types and pets here...
};

export default reptiles;